import { useContext, useEffect, useState } from "react"
import { Container, Grid } from "@mui/material"

import { AppContext } from "../../../stores/App/AppStore"
import { UserContext } from "../../../stores/User/UserStore"
import { useFAQRepository } from "../../../repositories/FAQ/use-faq-repository"
import { trackPageView } from "../../../helpers/analytics/google-analytics-utils"
import { Route } from '../../../router'
import CommonBackButton from "../../atoms/CommonBackButton/CommonBackButton"
import FAQsList from "../../organisms/FAQsList/FAQsList"
import FaqNavigationTabs from "../../molecules/FaqNavigationTabs/FaqNavigationTabs"
import { FaqEntry, FaqTags } from "../../../types"
import { useMembershipRepository } from "../../../repositories/Membership/use-membership-repository"

import styles from "./FAQ.module.css"

const FAQ = () => {
    const { state } = useContext(AppContext)
    const { state: userState } = useContext(UserContext)

    const { retrieveFAQs, retrieveFAQTags } = useFAQRepository()
    const { retrieveMembership } = useMembershipRepository()

    const [tabIndex, setTabIndex] = useState(0)
    const [faqTagsList, setFaqTagsList] = useState<FaqTags[]>([])
    const [faqEntriesList, setFaqEntriesList] = useState<FaqEntry[]>([])

    const membershipType = userState.membership?.data?.type

    const defaultAllFaqTag = {
        id: 0,
        tag: `All`,
        order: 1,
    }

    useEffect(() => {
        retrieveMembership()
    }, [])

    useEffect(() => {
        trackPageView(`FAQ`)
        if (membershipType) {
            retrieveFAQTags(membershipType)
            retrieveFAQs(membershipType)
        }
        window.scrollTo(0, 0)
    }, [membershipType])

    useEffect(() => {
        if (state.pages.faqTags) {
            setFaqTagsList([defaultAllFaqTag, ...state.pages.faqTags])
        }

        if (state.pages.faqs) {
            setFaqEntriesList(state.pages.faqs)
        }
    }, [state])

    const handleTabChange = (_: React.SyntheticEvent, newIndex: number) => {
        if (newIndex === 0) {
            setFaqEntriesList(state.pages.faqs)
        } else {
            const selectedTabIndex = newIndex
            const selectedTabFaqEntries = faqTagsList[selectedTabIndex].faqEntries ?? []
            setTabIndex(newIndex)
            setFaqEntriesList([...selectedTabFaqEntries])
        }
    }

    return (
        <Container className={styles.container}>
            <CommonBackButton path={Route.HOME} />
            <FaqNavigationTabs items={faqTagsList} selectedIndex={tabIndex} onTabChange={handleTabChange} />
            <Grid container direction="column" alignItems="center" spacing={2}>
                <Grid item className={styles.gridItem}>
                    <FAQsList faqEntries={faqEntriesList} />
                </Grid>
            </Grid>
        </Container>
    )
}

export default FAQ
